var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H35C37.7614 0 40 2.23858 40 5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.4211C22.2044 18.4211 21.4413 18.0883 20.8787 17.4961C20.3161 16.9039 20 16.1007 20 15.2632V11.0526H16C15.4696 11.0526 14.9609 11.2744 14.5858 11.6692C14.2107 12.0641 14 12.5995 14 13.1579V26.8421C14 27.4005 14.2107 27.9359 14.5858 28.3308C14.9609 28.7256 15.4696 28.9474 16 28.9474H25C25.5304 28.9474 26.0391 28.7256 26.4142 28.3308C26.7893 27.9359 27 27.4005 27 26.8421V18.4211H23ZM21 15.2632C21 15.8215 21.2107 16.357 21.5858 16.7518C21.9609 17.1466 22.4696 17.3684 23 17.3684H26.59L21 11.4842V15.2632ZM16 10H21L28 17.3684V26.8421C28 27.6796 27.6839 28.4829 27.1213 29.0751C26.5587 29.6673 25.7956 30 25 30H16C15.2044 30 14.4413 29.6673 13.8787 29.0751C13.3161 28.4829 13 27.6796 13 26.8421V13.1579C13 12.3204 13.3161 11.5171 13.8787 10.9249C14.4413 10.3327 15.2044 10 16 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.5a20de8bd05ac2e53cc0a0efa4e38228.svg";
export { ForwardRef as ReactComponent };